export default "__VITE_ASSET__CbAollp___"